
import {computed, defineComponent, ref} from 'vue';
import {OioButton, OioDateTimePicker, OioModal} from '@kunlun/vue-ui-antd';
import {MinusCircleOutlined, PlusCircleOutlined} from '@ant-design/icons-vue';
import {SelectOption} from '../../../types';
import {cloneDeep} from 'lodash-es';

export default defineComponent({
  name: 'customizeBatchUpdateView',
  components: {OioButton, MinusCircleOutlined, PlusCircleOutlined, OioDateTimePicker, OioModal},
  props: ['selectRecords', 'setRootTableData'],
  setup(props) {
    let count = 1;
    const originalEditTypeOptions = ref([
      {label: '记账时间规则', value: 'accountTimeRule'},
      {label: '指定账期天数', value: 'paymentDays'},
      {label: '指定记账时间', value: 'accountDate'}
    ]);
    const batchEditModalVisible = ref(false);
    const tableLoading = ref(false);
    const freeReasonOptions = ref<SelectOption[]>([]);
    const timeRuleOptions = ref<any[]>([
      {
        label: '按发货时间记账',
        value: 'DELIVERY_TIME'
      },
      {
        label: '按指定时间记账',
        value: 'TARGET_TIME'
      }
    ]);

    const getPopupContainer = (triggerNode: HTMLElement) => {
      let curNode = triggerNode;
      while (curNode) {
        if (curNode.id === 'TOID-content' || curNode.id === 'TOID-PROMOTION-CELL') {
          return curNode;
        }
        curNode = curNode.parentNode as HTMLElement;
      }
      return document.body;
    };

    const getOriginEditModalDataList = () => {
      // const result: {
      //   type?: typeof originalEditTypeOptions[number]['value'];
      //   value?: any;
      //   id: number;
      // }[] = [
      //   { id: 0, type: 'isGifted', value: true },
      //   { id: 1, type: 'isExamine', value: false }
      // ];
      // if (props.isPromotionOrder) {
      //   delete result[0].value;
      // }
      // return result;
      return [{id: 0}] as { type?: typeof originalEditTypeOptions.value[number]['value']; value?: any; id: number }[];
    };
    const editModalDataList = ref(getOriginEditModalDataList());
    const handleBatchEditBtnClick = () => {
      batchEditModalVisible.value = true;
      editModalDataList.value = getOriginEditModalDataList();
    };
    const onSubmitBatchEdit = async () => {
      batchEditModalVisible.value = false;
      tableLoading.value = true;
      try {
        await applyBatchEdit();
      } finally {
        tableLoading.value = false;
      }
    };
    const displayEditTypeOptions = computed(() => {
      type Writeable<T> = { -readonly [P in keyof T]: T[P] };
      const copy: any[] = cloneDeep(originalEditTypeOptions.value);
      copy.forEach((item) => {
        if (editModalDataList.value.some((data) => data.type === item.value)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      return copy;
    });


    const applyBatchEdit = async () => {
      if (editModalDataList.value.every((item) => item.value === undefined)) {
        return;
      }
      props.selectRecords.forEach((item) => {
        item.outCode &&
        editModalDataList.value.forEach(({type, value}) => {
          if (type && value !== undefined) {
            item[type] = value;
            // 记账时间规则
            if (['accountTimeRule', 'paymentDays', 'accountDate'].includes(type)) {
              // 指定天数时，时间置空
              if (item.accountTimeRule === 'DELIVERY_TIME') {
                item.accountDate = null;
              }
              // 指定时间时，天数置空
              else {
                item.paymentDays = null;
              }
            }
          }
        });
      });
      tableLoading.value = true;
      props.setRootTableData(props.selectRecords);
      // try {
      //   await orderPreview();
      // } finally {
      //   tableLoading.value = false;
      // }
    };

    const addEditModalRow = () => {
      editModalDataList.value.push({
        id: count++
      });
    };

    const removeEditModalRow = (id: number) => {
      editModalDataList.value = editModalDataList.value.filter((item) => item.id !== id);
    };

    const itemSelect = (value, option) => {
      if (value === 'DELIVERY_TIME') {
        editModalDataList.value = editModalDataList.value.filter((item) => item.type !== 'accountDate');
        if (editModalDataList.value.findIndex((item) => item.type === 'paymentDays') === -1) {
          editModalDataList.value.push({
            id: count++,
            type: 'paymentDays',
          });
        }
      }
      // 指定时间时，天数置空
      else {
        editModalDataList.value = editModalDataList.value.filter((item) => item.type !== 'paymentDays');
        if (editModalDataList.value.findIndex((item) => item.type === 'accountDate') === -1) {
          editModalDataList.value.push({
            id: count++,
            type: 'accountDate',
          });
        }
      }
    }

    const typeChange = (value, option) => {
      editModalDataList.value.forEach((item) => {
        if (item.type === value) {
          item.value = null;
        }
      })
    }

    return {
      originalEditTypeOptions,
      freeReasonOptions,
      timeRuleOptions,
      getPopupContainer,
      editModalDataList,
      onSubmitBatchEdit,
      applyBatchEdit,
      addEditModalRow,
      removeEditModalRow,
      displayEditTypeOptions,
      handleBatchEditBtnClick,
      batchEditModalVisible,
      itemSelect
    };
  }
});
